module.exports = __webpack_public_path__ + "img/slide8.2502ac7c.png";